import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { FormattedMessage  } from 'react-intl';

import axios from 'axios'

import LoadingControl from './Loading';
import { PRINTERS_PATH, SERVERS_PATH, USERS_PATH, COMPUTERS_PATH, DOCUMENTS_PATH } from '../utils/constants';
import { TrimNan, getCurrencySymbol, formatBytes } from '../utils/utils';
import {ApplyFilterParams} from '../utils/ApplyFilterParams'
import DescriptionObject from './DescriptionObject';
import DocumentsTable from './DocumentsTable';
import ChartDistribution from './ChartDistribution';
import { GetMostActiveColumns } from './GetMostActiveObjectsColumn';
import MostActiveObjectsTable from './MostActiveObjectsTable';


class ServerReportGeneral extends Component {

    constructor (props) {
        super(props);

        this.serverId = TrimNan(parseInt(this.props.params['id'], 10));
        this.daysNumber = null;

        this.state = {
            error: null,
            isLoaded: false,
            server: null
          };
    }

    async getData() {

        var url = ApplyFilterParams("/server/" + this.serverId + "?doNotReturnEmptyObjects=false", this.props.filterData);
        
        const res = await axios(url);
        return res.data;
        }

    update() {
        this.setState({isLoaded: false});
    
        this.getData()
        .then(res => {
            this.setState({ error: null, isLoaded: true, server: this.getColumns(res) });
        })
        .catch(err => {
            console.log(err);
            this.setState( {error: err, isLoaded: false, server: null });
        });
        }  
        
    componentDidMount() {
        if (this.serverId <= 0)
        {
            this.setState( {error: {message : "Bad server id"}});
        }
        else
        {
            this.update();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.filterData !== this.props.filterData) {
            this.update();
        }
    }

    getColumns(res)
    {
        const lang = navigator.language || navigator.userLanguage;

        var data = [];
        if ((res instanceof Array) && res.length > 0)
        {
            data = data = res[0];
        }

        let dateMin = new Date(data.minDate);
        let dateMax = new Date(data.maxDate);

        let reportPeriod = "";
        if (isNaN(dateMin) || isNaN(dateMax))
        {
            this.daysNumber = null;
        }
        else
        {
            this.daysNumber = Math.round(dateMax.getTime() - dateMin.getTime()) / (1000 * 60 * 60 * 24);

           reportPeriod = dateMin.toLocaleDateString(lang) + ' - ' + 
                    dateMax.toLocaleDateString(lang);

        }

        const formatConfig = {
            style: 'currency',
            currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
            minimumFractionDigits: 2,
            currencyDisplay: 'symbol',
        };

        const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

        var columns = [
            {
                title :  <FormattedMessage id="Server"/>,
                data : data.srvName,
            },
            {
                title : <FormattedMessage id="Version"/>,
                data : data.version,
            },
            {
                title : <FormattedMessage id="LastALive"/>,
                data : data.lastAlive === undefined ? "" : new Date(data.lastAlive).toLocaleString(lang),
            },
            {
                title : <FormattedMessage id="Users"/>,
                data : data.users,
                link: USERS_PATH + "?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Printers"/>,
                data : data.printers,
                link: PRINTERS_PATH + "?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Computers"/>,
                data : data.computers,
                link: COMPUTERS_PATH + "?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Report.PrintedJobs"/>,
                data : data.documents,
                link: DOCUMENTS_PATH + "?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Pages"/>,
                data : data.pages,
            },
            {
                title : <FormattedMessage id="Cost"/>,
                data : currencyFormatter.format(data.cost === undefined ? 0 : data.cost),
            },
            {
                title : <FormattedMessage id="JobDataSize"/>,
                data : formatBytes(data.jobDataSize === undefined ? 0 : data.jobDataSize),
            },
            {
                title : <FormattedMessage id="ReportPeriod"/>,
                data : reportPeriod,
            },
        ];

        return columns;
    }

    render(){

        if(this.state.error != null)
        {
            return (
                <div>
                    <h3>{this.state.error.message}</h3>
                    <Link to={SERVERS_PATH}><FormattedMessage id="Back"/></Link>
                </div>
            );
        }
        else if (!this.state.isLoaded)
        {
            return (
                <div><LoadingControl/></div>
            );
        }
        else
        {          
            if (this.state.server === null)
            {
                return ( 
                    <div>
                        <FormattedMessage id="ObjectNotFound"/>
                        <Link to={SERVERS_PATH}><FormattedMessage id="Back"/></Link>
                    </div>
                );
            }
            
            return (
            <div>
                <div className = "description-parent">
                    <div className = "description-object"><DescriptionObject object = {this.state.server}/></div>
                    <div className = "description-object"><ChartDistribution object_id = {'serverId=' + this.serverId}/></div>
                </div>
                <br/>
                <br/>
                <h4><FormattedMessage id="LastDocuments"/></h4>
                <DocumentsTable parent_id_param = {'?serverId=' + this.serverId} 
                                api_url = {ApplyFilterParams('job?maxCount=20&serverId=' + this.serverId, this.props.filterData)}/>
                <h4><FormattedMessage id="MostActivePrinters"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?serverId=' + this.serverId} 
                    api_url = {ApplyFilterParams('printer_ex?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&serverId=' + this.serverId, this.props.filterData)}
                    get_columns = {GetMostActiveColumns(PRINTERS_PATH, '?serverId=' + this.serverId, this.daysNumber)}

                />
                <h4><FormattedMessage id="MostActiveUsers"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?serverId=' + this.serverId} 
                    api_url = {ApplyFilterParams('user?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&serverId=' + this.serverId, this.props.filterData)}
                    days_number = {this.daysNumber}
                    get_columns = {GetMostActiveColumns(USERS_PATH, '?serverId=' + this.serverId, this.daysNumber)}
                />
                <h4><FormattedMessage id="MostActiveComputers"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?serverId=' + this.serverId} 
                    api_url = {ApplyFilterParams('computer?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&serverId=' + this.serverId, this.props.filterData)}
                    days_number = {this.daysNumber}
                    get_columns = {GetMostActiveColumns(COMPUTERS_PATH, '?serverId=' + this.serverId, this.daysNumber)}
                />
            </div>
        )
    }
  }
}
export default ServerReportGeneral;